import { Media as _Media, MediaProps as _MediaProps } from "reactstrap";

    export const Media = _Media;
    export type MediaProps = _MediaProps;
    